<!-- <div fxLayout="column" fxFlex.lt-md="100" fxFlex="48" class="form-block">
    <h3>{{'admin-center.header.employeeCompanyData' | translate}}</h3>
    <span *ngIf="!employeeCompany">{{'validations.errorWhenLoadingData' | translate}}</span>
    <div>
        <form *ngIf="employeeCompany" [formGroup]="editDataForm">
            <div fxLayout="column">
                <app-employee-company-form [form]="editDataForm"></app-employee-company-form>
            </div>
        </form>
    </div>
</div> -->

<div fxLayout="column" fxFlex="25" fxFlex.lt-md="100" class="form-block" *ngIf="employeeCompany" fxLayoutGap="5px">
    <app-employee-company-associated-employees  [associatedEmployeeCompanyId]="employeeCompany.id"></app-employee-company-associated-employees>
</div>